import { useState } from 'react';
import { Form, Row, Col, Typography } from 'antd';
import { UserOutlined, LockOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { UiButton, UiTextBox } from '../../../components';
import '../style.scss';

const { Link } = Typography;
const Loginform = ({
  onForgotPassword,
  onSubmit,
  username,
  password,
  onUsernameChange,
  onPasswordChange,
  loading,
  isFormValid,
  form,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleForgotPassword = (event) => {
    event.preventDefault();
    if (onForgotPassword) {
      onForgotPassword();
    }
  };

  const onFinish = (values) => {
    if (onSubmit) onSubmit(values);
  };

  return (
    <>
      <div className="login-content-welcome-title">
        Welcome Back, Admin
      </div>
      <div className="login-content-welcome-subtitle">
        Sign in to manage lawyers, clients, and appointments.
      </div>
      <Form
        form={form}
        name="login"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        size="large"
        className="login-form"
      >
        <Form.Item
          name="username"
          rules={[
            {
              required: true,
              message: 'Please enter mobile number',
            },
            {
              len: 10,
              message: 'Mobile number must be 10 digits',
            },
            {
              pattern: /^[0-9]+$/,
              message: 'Mobile number can only contain numbers',
            },
            {
              whitespace: true,
              message: 'Mobile number cannot be empty',
            },
          ]}
          className="login-form-item"
        >
          <UiTextBox
            prefix={<UserOutlined style={{ marginRight: 8 }} />}
            placeholder="Mobile Number"
            className="login-input"
            required={true}
            type="tel"
            inputMode="numeric"
            maxLength={10}
            value={username}
            onKeyDown={(event) => {
              if (event?.ctrlKey || event?.metaKey) return;
              const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
              if (allowed.includes(event.key)) return;
              if (!/^[0-9]$/.test(event.key)) {
                event.preventDefault();
              }
              if (/^[0-9]$/.test(event.key) && (username?.length || 0) >= 10) {
                event.preventDefault();
              }
            }}
            onPaste={(event) => {
              const text = (event.clipboardData?.getData('text') || '');
              if (!/^[0-9]+$/.test(text)) {
                event.preventDefault();
                return;
              }
              if ((username?.length || 0) + text.length > 10) {
                event.preventDefault();
              }
            }}
            onChange={(event) => {
              const onlyNums = (event?.target?.value || '').replace(/\D/g, '').slice(0, 10);
              if (onUsernameChange) {
                onUsernameChange({ ...event, target: { ...event.target, value: onlyNums } });
              }
            }}
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: 'Please input your password!',
            },
            {
              max: 16,
              message: 'Password cannot exceed 16 characters',
            },
          ]}
          className="login-form-item"
        >
          <UiTextBox
            type={showPassword ? 'text' : 'password'}
            prefix={<LockOutlined style={{ marginRight: 8 }} />}
            suffix={
              <span
                onClick={() => setShowPassword((prev) => !prev)}
                onMouseDown={(event) => event.preventDefault()}
                style={{ cursor: 'pointer', color: '#999' }}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                role="button"
              >
                {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              </span>
            }
            placeholder="Password"
            className="login-input"
            required={true}
            maxLength={16}
            value={password}
            onChange={onPasswordChange}
          />
        </Form.Item>
        <Row justify="space-between" align="middle" className="login-remember-row">
          <Col>
            <Form.Item name="remember" valuePropName="checked" noStyle>
              {/* <Checkbox className="login-checkbox">
                <div className="login-checkbox-label">Remember me</div>
              </Checkbox> */}
            </Form.Item>
          </Col>
          <Col>
            <Link
              href="#"
              onClick={handleForgotPassword}
              className="login-forgot-link"
            >
              Forgot your password ?
            </Link>
          </Col>
        </Row>
        <Form.Item className="login-form-item-last">
          <UiButton
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={!isFormValid}
            className={`login-submit-button ${isFormValid ? 'login-submit-button-enabled' : ''}`}
          >
            Sign In
          </UiButton>
        </Form.Item>
      </Form>
    </>
  );
};

export default Loginform;
